import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ current, total, showPercentage = true }) => {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="mb-4 sm:mb-6">
      <div className="flex justify-between mb-2 sm:mb-3">
        <span className="text-xs sm:text-sm font-semibold text-gray-700">
          Question {current} of {total}
        </span>
        {showPercentage && (
          <span className="text-xs sm:text-sm font-bold bg-gradient-to-r from-violet-600 to-pink-600 bg-clip-text text-transparent">
            {percentage}%
          </span>
        )}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 sm:h-3 overflow-hidden shadow-inner">
        <motion.div
          className="bg-gradient-to-r from-violet-600 to-pink-600 h-2 sm:h-3 rounded-full relative overflow-hidden"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {/* Shine effect */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30"
            animate={{
              x: ['-100%', '200%']
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "linear"
            }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default ProgressBar;
